import { defineMessages } from 'react-intl';

export default defineMessages({
    searchForTopic: {
        id: 'faq.directive.Search for a topic',
        defaultMessage: 'Search for a topic',
    },
    generalBilling: {
        id: 'faq.sections.My Billing',
        defaultMessage: 'My Billing',
    },
    claim: {
        id: 'faq.sections.My Claims',
        defaultMessage: 'My Claims',
    },
    customizeFAQContent: {
        id: 'faq.sections.How to customize the FAQ content',
        defaultMessage: 'How to customize the FAQ content',
    },
    frequentlyAskedQuestions: {
        id: 'faq.directive.Frequently Asked Questions',
        defaultMessage: 'Frequently Asked Questions',
    },
    differentWaysToPay: {
        id: 'faq.topics.payment_methods.question',
        defaultMessage: 'What are the different ways to pay for my insurance policy?',
    },
    creditCardPayment: {
        id: 'faq.topics.payment_methods.link.To make a one time credit card payment, please click here.',
        defaultMessage: 'To make a one time credit card payment, please click here.',
    },
    correctBillingMistake: {
        id: 'faq.topics.billing_mistake.question',
        defaultMessage: 'How can I correct a billing mistake made in the last three months?',
    },
    reportBillingMistake: {
        id: 'faq.topics.billing_mistake.link.To report a billing mistake on your last statement, please click here.',
        defaultMessage: 'To report a billing mistake on your last statement, please click here.',
    },
    claimProcess: {
        id: 'faq.topics.when_to_claim.question',
        defaultMessage: 'When is it best to begin the claim process after something happened to my house?',
    },
    renewlaCostInFuture: {
        id: 'faq.topics.claim_rate_increase.question',
        defaultMessage: 'In the event of a claim against the insurance policy, will my insurance costs increase at renewal or at any time in the future?',
    },
    deductible: {
        id: 'faq.topics.deductible_payment.question',
        defaultMessage: 'Under what circumstances would I have to pay a deductible when making a claim?',
    },
    FaqTopic: {
        id: 'faq.topics.show_video.question',
        defaultMessage: 'How to make a youtube video appear in the answer for a FAQ topic?',
    },
    clickableLink: {
        id: 'faq.topics.show_link.question',
        defaultMessage: 'How can I show a clickable link appear in the answer for a FAQ topic?',
    },
    customText: {
        id: 'faq.topics.show_link_text.question',
        defaultMessage: 'How can I show custom text that can be clicked to access a link in the answer for a FAQ topic?',
    },
    clickedText: {
        id: 'faq.topics.show_link_text.This text can be clicked.',
        defaultMessage: 'This text can be clicked.',
    },
    formattingQuestion: {
        id: 'faq.topics.formatting.question',
        defaultMessage: 'How can I customize the format of the question and answer elements for a given topic?',
    },
    bankTransfer: {
        id: 'faq.topics.payment_methods.answer.long',
        defaultMessage: 'Payments can be made using a major credit/debit card or a bank transfer.',
    },
    billngMistake: {
        id: 'faq.topics.billing_mistake.answer.long',
        defaultMessage: 'Billing mistakes should be brought to our attention as soon as they are found to ensure that they are promptly corrected. Please make sure to gather as much information about the mistake such as the date and amounts. You may then contact us through email, chat or phone.',
    },
    eventClaim: {
        id: 'faq.topics.when_to_claim.answer.long',
        defaultMessage: 'In order for us to best serve you in time of need, please notify us of any event that may lead to a claim as soon as you can reasonably expect to make a claim against your insurance policy.',
    },
    increasedRates: {
        id: 'faq.topics.claim_rate_increase.answer.long',
        defaultMessage: 'Filing a claim will not necessarily result in increased rates. Several factors are considered when rating a policy renewal.',
    },
    deductibleAmountasedRates: {
        id: 'faq.topics.deductible_payment.answer.long',
        defaultMessage: 'If the policy stipulates a deductible amount, the deductible amount must be covered when making a claim against the policy.',
    },
    navigateToVideo: {
        id: 'faq.topics.show_video.answer.long',
        defaultMessage: 'Using your browser, navigate to the youtube video that you would like to show. Copy the hash part of the url, for example in the following URL https://www.youtube.com/watch?v=XHB609to9dg the video hash is XHB609to9dg. Insert the video hash inside the topic object under a key named videoId.',
    },
    navigateToExternalLink: {
        id: 'faq.topics.show_link.answer.long',
        defaultMessage: 'Using your browser, navigate to the external link that you would like to show. Copy the url from the browser and insert into a new object as the value for the key url.',
    },
    navigateToExternalLinkText: {
        id: 'faq.topics.show_link_text.answer.long',
        defaultMessage: 'Using your browser, navigate to the external link that you would like to show. Copy the url from the browser and insert into a new object as the value for the key url.',
    },
    customFaq: {
        id: 'faq.topics.formatting.answer.long',
        defaultMessage: 'You can use html markup to customize the FAQ such as:<h2>A list example</h2><ul><li><a href="http://example.com">The first item is a link</a></li><li>The second item is <strong>an emphasis</strong></li><li>The third item is a spinner image <img src="throbber.gif" /></li><li>The fourth item is an escape of the tag &lt;div&gt;</li></ul>',
    },
    typeQuestion: {
        id: 'faq.directive.Start typing your question...',
        defaultMessage: 'Start typing your question...',
    },
    sections: {
        id: 'faq.directive.Sections',
        defaultMessage: 'Sections',
    },
    noMatchingError: {
        id: 'faq.directive.No matching results found',
        defaultMessage: 'No matching results found',
    },
    aboutThePortal: {
        id: 'faq.sections.About the Portal',
        defaultMessage: 'About the Portal',
    },
    purposeOfClaimPortal: {
        id: 'faq.topics.about_portal_for_ph.inline_question',
        defaultMessage: 'What is the purpose of the Claim Portal for Policy Holders?',
    },
    purposeOfClaimPortalQuestion: {
        id: 'faq.topics.about_portal_for_ph.question',
        defaultMessage: 'What is the purpose of the Claim Portal for Policy Holders?',
    },
    purposeOfClaimPortalShortAnswer: {
        id: 'faq.topics.about_portal_for_ph.answer.short',
        defaultMessage: 'Claim Portal for Policyholders can be used to file a claim against a policy based on one or more lines of business',
    },
    purposeOfClaimPortalLongAnswer: {
        id: 'faq.topics.about_portal_for_ph.answer.long',
        defaultMessage: 'Claim Portal for Policyholders can be used to file a claim against a policy based on one or more lines of business.',
    },
    purposeOfClaimPortalProducer: {
        id: 'faq.topics.about_portal_for_producers.inline_question',
        defaultMessage: 'What is the purpose of the Claim Portal for Agents?',
    },
    purposeOfClaimPortalQuestionProducer: {
        id: 'faq.topics.about_portal_for_producers.question',
        defaultMessage: 'What is the purpose of the Claim Portal for Agents?',
    },
    purposeOfClaimPortalShortAnswerProducer: {
        id: 'faq.topics.about_portal_for_producers.answer.short',
        defaultMessage: 'The Claim Portal for Agents is intended for agents that can act on behalf of the insured.',
    },
    purposeOfClaimPortalLongAnswerProducer: {
        id: 'faq.topics.about_portal_for_producers.answer.long',
        defaultMessage: 'The Claim Portal for Agents is intended for agents that can act on behalf of the insured and perform actions like filing a new claim or verifying the status of an existing one.',
    },


    preferencesHeading: {
        id: 'faq.sections.My AGM',
        defaultMessage: 'My AGM',
    },
    policyHeading: {
        id: 'faq.sections.My Policy',
        defaultMessage: 'My Policy',
    },
    insuranceProof: {
        id: 'faq.topics.insurance.proof.question',
        defaultMessage: 'How can I access my proof of Insurance (pink card)?',
    },
    insuranceProofAns: {
        id: 'faq.topics.insurance.proof.answer',
        defaultMessage: 'Once logged in, you can view all active policies on the Homepage. When "View Details is selected on an active policy listed on the Homepage. From this page, you can access your auto proof of insurance.',
    },
    downloadPolicyDoc: {
        id: 'faq.topics.download.policy.question',
        defaultMessage: 'How can I download policy documents?',
    },
    downloadPolicyDocAns: {
        id: 'faq.topics.download.policy.answer',
        defaultMessage: 'After successfully logging in, you will be greeted by your homepage. Select "My Documents from the tab bar to view all documents associated with your open policies. On this tab, you can view and download these documents.',
    },
    uploadPolicyDoc: {
        id: 'faq.topics.upload.policy.question',
        defaultMessage: 'How can I upload policy documents?',
    },
    uploadPolicyDocAns: {
        id: 'faq.topics.upload.policy.answer',
        defaultMessage: 'Click "View Details" from the Homepage next to the policy to which you wish to attach documents. To add additional documentation to a selected policy, click the chevron to the right of "My Policy Documents." Here, you can see all documents already associated with the policy. You can drag and drop files from your desktop or use the file selector to upload additional files.',
    },
    policyPayments: {
        id: 'faq.topics.policy.payments.question',
        defaultMessage: 'How can I make policy payments?',
    },
    policyPaymentsAns: {
        id: 'faq.topics.policy.payments.answer',
        defaultMessage: 'Policy payments are made on the Heartland website which can be accessed via Optim. Select the "Make a Payment" button on the top right of the Homepage to be redirected to the Heartland website. Then select the appropriate payment option and insert the necessary information.',
    },
    accountPreferences: {
        id: 'faq.topics.account.preferences.question',
        defaultMessage: 'How can I get Annual General Meeting(AGM) materials?',
    },
    accountPreferencesAns: {
        id: 'faq.topics.account.preferences.answer',
        defaultMessage: 'On your homepage, from the tab bar, select "My Preferences" to either opt-in or opt-out of receiving Annual General Meeting(AGM) Materials In addition, you can choose to receive materials electronically or by Canada Post. Remember to save each change by selecting the blue "Save Changes" button.',
    },
    claimPayments: {
        id: 'faq.topics.claim.payments.question',
        defaultMessage: 'How Can I Start Receiving Claim Payments by Electronic Funds Transfer (EFT)?',
    },
    claimPaymentsAns: {
        id: 'faq.topics.claim.payments.answer',
        defaultMessage: '<ol><li>Before you can receive claim payments by EFT, you must confirm with your adjuster that the claim is eligible to do so.</li><li>Navigate to your open claims by clicking on the "My Claims" tab. Click "Details" and then click "Receive Payments by Electronic Fund Transfer". Input all information into the open boxes. Click the information icon to the right for details on the required fields.</li></ol>',
    },
    reportClaim: {
        id: 'faq.topics.report.claim.question',
        defaultMessage: 'How can I report a claim?',
    },
    reportClaimAns: {
        id: 'faq.topics.report.claim.answer',
        defaultMessage: 'Select the “Report A Claim” button in the top-right corner of your Homepage. Indicate the date and Policy on which the loss occurred. Fill in all required information, noting where and what happened in the appropriate fields and attach the necessary documentation.',
    },
    viewBilling: {
        id: 'faq.topics.view.billing.question',
        defaultMessage: 'How can I View and Manage my billing information?',
    },
    viewBillingAns: {
        id: 'faq.topics.view.billing.answer',
        defaultMessage: 'Navigate to your billing information by clicking the "My Billing" tab. In Optim, you can view - but not change your billing information. Select the "My Billing" tab to view all billing details for your active policies.',
    },
    viewClaims: {
        id: 'faq.topics.view.claims.question',
        defaultMessage: 'How can I view and manage my current claims?',
    },
    viewClaimsAns: {
        id: 'faq.topics.view.claims.answer',
        defaultMessage: 'The second tab on the homepage titles “My Claims” will bring you to the My Claims Landing Page. From here, you can view the details of claims associated with your active policies.',
    },
    viewPolicies: {
        id: 'faq.topics.view.policies.question',
        defaultMessage: 'How can I view and manage my policies?',
    },
    viewPoliciesAns: {
        id: 'faq.topics.view.policies.answer',
        defaultMessage: 'When “View Details” is selected on an active policy listed on the Homepage, the details of the policy will open. From this page, you can view contact information for your Broker/Agent, view all policy details, add documents, view payment information, and make some changes to the active policy.',
    },
    goPaperless: {
        id: 'faq.sections.Go Paperless',
        defaultMessage: 'Go Paperless',
    },
    howPaperless: {
        id: 'faq.topics.view.goPaperless.question',
        defaultMessage: 'How can I "Go Paperless"?',
    },
    howPaperlessAnswer: {
        id: 'faq.topics.view.goPaperless.answer',
        defaultMessage: 'On your homepage, from the tab bar, select "Go Paperless",\n'
            + 'from there you can change document preferences for active policies. Change each preference to "Email" to receive digital copies. Remember to save\n'
            + 'each change by selecting the blue "Save Changes" button.',
    },
});
